import { IResponse } from '../../../interfaces/common-interfaces';
import { DEFAULT_ERROR } from '../../../DAL/data-provider';

export const getFirstServerError = (response: IResponse) => {

    let error = DEFAULT_ERROR;
    if(!response) return error;

    if(response.data && response.data.errors && response.data.errors.length > 0){
        return response.data.errors[0] || DEFAULT_ERROR;
    }

    if(response.errors && response.errors.length > 0){
        return response.errors[0] || DEFAULT_ERROR;
    }

    return error;
};